import React from 'react';
import { Check } from 'lucide-react';
import { solutions } from '../mock';
import Reveal from './Reveal';

const Solutions = ({ onEnquire }) => {
  return (
    <section id="solutions" className="bg-[#0B1430] py-24 relative overflow-hidden">
      {/* Subtle radial gold glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        aria-hidden="true"
        style={{
          background:
            'radial-gradient(ellipse at 20% 20%, rgba(212,168,83,0.10) 0%, rgba(212,168,83,0) 55%)',
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Heading */}
        <Reveal variant="up">
          <div className="mb-14">
            <div className="text-[#D4A853] tracking-[0.3em] text-xs font-semibold mb-3">
              OUR SOLUTIONS
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.05] text-white">
              A Solution for
              <br />
              <span className="text-white/60 font-light">Every Home.</span>
            </h2>
          </div>
        </Reveal>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {solutions.map((s, i) => (
            <Reveal key={s.title} variant="up" delay={i * 150}>
              <div className="group relative bg-[#0F1A3A] border border-white/5 rounded-2xl overflow-hidden lift-on-hover flex flex-col h-full">
                {/* Image + badge */}
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  {/* Bottom dark fade for readability */}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0F1A3A] via-transparent to-transparent" />
                  {/* Badge */}
                  <div className="absolute top-4 right-4">
                    <span className="inline-block px-4 py-1.5 rounded-full bg-[#D4A853] text-[#0B1430] text-[11px] font-semibold tracking-wide shadow-lg">
                      {s.badge}
                    </span>
                  </div>
                </div>

                {/* Body */}
                <div className="p-7 flex flex-col flex-1">
                  <h3 className="text-white text-2xl font-bold mb-6">
                    {s.title}
                  </h3>

                  <ul className="space-y-3.5 mb-8 flex-1">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-start gap-3 text-white/80 text-[14px] leading-relaxed">
                        <span className="mt-0.5 w-5 h-5 rounded-full bg-[#D4A853]/15 flex items-center justify-center shrink-0">
                          <Check size={12} className="text-[#D4A853]" strokeWidth={3} />
                        </span>
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>

                  <button
                    onClick={onEnquire}
                    className="w-full py-3.5 rounded-md border border-white/20 text-white font-semibold text-[13px] hover:bg-[#D4A853] hover:border-[#D4A853] hover:text-[#0B1430] transition-colors duration-300"
                  >
                    Enquire Now
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
